import React from 'react'
import MainHeader from '../Sidebar/MainHeader'

function AboutAI() {
    return (
        <div>
            <div class="main-panel">
                <MainHeader />
                <div class="container">
                    <div class="page-inner text-center">
                        <h3 className='mb-3'>About HolaAI</h3>
                        <div className='row justify-content-center'>
                            <div className='col-11'>
                                <div class="card p-4">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                                    <img src="assets/img/phot.jpg" className='img-fluid mb-3' alt="" />
                                    <p><strong>Why do we use it?</strong><br />
                                        It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutAI